import { render, staticRenderFns } from "./worksList.vue?vue&type=template&id=f33f33b2&"
import script from "./worksList.vue?vue&type=script&lang=js&"
export * from "./worksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports